import * as z from 'zod';
import { finalContractSuretyBondClosedReasonSchema } from '../../../../enums.mjs';
import { isoDateSchema } from '../../../opaque.mjs';
import { currencySchema } from '../../../utils.mjs';
import { Data as Data$1 } from './contract-surety-bond.types.mixins.mjs';

var Data;
(function (Data) {
    Data.schema = Data$1.baseSchema.extend({
        contractSuretyType: z.literal("final"),
        closedReason: finalContractSuretyBondClosedReasonSchema.nullish(),
        contractAmount: currencySchema,
        contractDate: isoDateSchema,
        project: Data$1.projectSchema,
        expectedCompletionDate: isoDateSchema.nullish(),
        actualCompletionDate: isoDateSchema.nullish(),
        actualContractAmount: currencySchema.nullish(),
    });
})(Data || (Data = {}));
var Close;
(function (Close) {
    (function (Payload) {
        Payload.baseSchema = z.object({
            suretyType: z.literal("contract"),
            contractSuretyType: z.literal("final"),
            closedNote: z.string().nullish(),
        });
        Payload.projectCompletedReasonsSchema = Payload.baseSchema.omit({ closedNote: true }).extend({
            closedReason: finalContractSuretyBondClosedReasonSchema.extract(["project_completed"]),
            actualCompletionDate: isoDateSchema,
            actualContractAmount: currencySchema,
        });
        Payload.allOtherReasonsSchema = Payload.baseSchema.extend({
            closedReason: finalContractSuretyBondClosedReasonSchema.exclude(["project_completed"]),
        });
        Payload.schema = z.discriminatedUnion("closedReason", [
            Payload.projectCompletedReasonsSchema,
            Payload.allOtherReasonsSchema,
        ]);
    })(Close.Payload || (Close.Payload = {}));
})(Close || (Close = {}));

export { Close, Data };
